export interface SaveThenGenerateDeps {
  /** 保存动作；resolve true 表示保存成功，可继续生成 */
  save: () => Promise<boolean>;
  /** 生成动作；仅在保存成功后调用 */
  generate: () => void | Promise<void>;
}

/**
 * 「保存并生成」时序：先 await save()，成功(true)才 generate()。
 * save 抛错则向上抛，不调用 generate。
 */
export async function saveThenGenerate(deps: SaveThenGenerateDeps): Promise<void> {
  const ok = await deps.save();
  if (ok) await deps.generate();
}
